Revolution.Module.extend({
    NAME: "mde.forms", // OBLIGATOIRE (reflète l'arborescence répertoire : /mde/main.js)

    initialize: function ($) {
        // appelé aussitôt la page chargée
        //console.log("module " + this.NAME);

        //_.bindAll(this, "closeNavMob", "showBtnExpendTouch");
        //

        //events
        this.initInputFile();

        $('.label-number').closest('label').prev().on('change', this.checkboxesCounter);
        $('.js-uncheck-options').on('click', this.uncheckOptions);

        $('body').on('change', '.js-conditional-radio', this.conditionnalRadio);

        $('body').on('click', '.js-add-form-line', this.addFormLine);
        $('body').on('click', '.js-remove-line', this.removeFormLine);


        $('.js-only-numbers').mask('0#');

        if ($('.js-form-popup-newsletter').length) {
            $('.js-form-popup-newsletter').parsley();
            $('.js-btn-popup-newsletter').on('click', function() {
                $('.js-email-field-copied').val($('.js-email-field').val());
            });
        }
    },

    onWindowLoad: function (e) {

    },

    onWindowScroll: function (e) {

    },
    onWindowResize: function (e) {

    },

    removeFormLine: function (e) {
        var $obj = $(e.currentTarget);
        $obj.closest('.js-added-line').remove();
    },

    addFormLine: function (e) {
        var $obj = $(e.currentTarget);
        var $parent = $obj.closest('.js-add-form-line-wrapper');
        var templating = $parent.find('[type="text/template"]').html();
        var $wrapper = $parent.find('.js-insert-wrapper');
        var nblines = $wrapper.find('> *').length;
        var renderTemplate = templating.replace(/{i}/g, nblines + 1);

        $wrapper.append(renderTemplate);
        $.applyDataMask();
        Revolution.get("mde.accessible-function").giveTempFocus($wrapper.find('.js-added-line:last-child'));
    },

    conditionnalRadio: function (e) {
        var $obj = $(e.currentTarget);
        var group = $obj.data('fields-group');
        var targets = $obj.data('fields');
        var targetsArray = targets.split(', ');

        $(group).find('.js-conditional').hide();
        $(group).find('.js-conditional').find('[data-required]').removeAttr('required');

        for(i=0; i < targetsArray.length; i++) {
            var target = targetsArray[i];
            $(target).show();
            $(target).find('[data-required]').attr('required', true);
        }
    },

    initInputFile: function () {
        $('.bk-input-file').each(function (index, el) {
            var $label   = $(el).find('label'),
                $input = $(el).find('input[type="file"]'),
                labelVal = $label.html();

            console.log($input);

            $input.on('change', function (e) {
                console.log(e.target.files[0]);
                if(e.target.files[0] != undefined) {
                    var fileName = e.target.files[0].name;
                    $label.find('.result').text(fileName);
                } else {
                    $label.find('.result').text($label.find('.result').attr('data-text'));
                }

                console.log(fileName);
            });
        });
    },
    clearInputFile : function (e) {
        var $obj = $(e.currentTarget);
        $obj.closest('label').prev('[type="file"]').val('');
        $obj.closest('label').find('.result').text('');
        $obj.hide();
    },

    checkboxesCounter: function(e) {

        var $obj = $(e.currentTarget);
        var $label = $(e.currentTarget).next('label');
        var $parent = $obj.closest('.bk-options');
        var nbChecked = $parent.find(':checked').length;

        if (nbChecked > 0) {
            $parent.next('.ta-c').find(':checked').prop('checked', false);
        }

        if ($obj.is(':checked')) {
            $label.find('.label-number').html(nbChecked);
        } else {
            var valDisable = parseInt($label.find('.label-number').html());
            $parent.find(':checked').each(function(index, elem) {
                var val = parseInt($(elem).next('label').find('.label-number').html());
                if (val > valDisable) {
                    $(elem).next('label').find('.label-number').html(val - 1);
                }
            });
        }
    },

    uncheckOptions: function (e) {
        var $obj = $(e.currentTarget);
        $obj.closest('.ta-c').prev('.bk-options').find(':checked').prop('checked', false);
    }


});
